import currencyFormatter from 'currency-formatter'
import i18n from '@/utils/i18n'
import store from '@/store'
import dateUtil from '@/utils/dateUtil'
import { emptyValue } from '@/utils/consts'
import { userStatusMapping } from '@/utils/locale'

const filters = {
  capitalize (value) {
    if (typeof value !== 'string') return value
    value = value.toString().toLowerCase()
    const words = value.split(' ')
    const capWords = []
    words.forEach(word => {
      capWords.push(word.charAt(0).toUpperCase() + word.slice(1))
    })
    return capWords.join(' ')
  },
  uppercase (value) {
    if (typeof value !== 'string') return value
    return value.toString().toUpperCase()
  },
  formatDate (value, format = 'DD MMM YY') {
    return dateUtil.format(value, format)
  },
  customValueByKey (value, options = {}) {
    let localeKey
    let path = options.rootPath
    if (options.obj) {
      localeKey = Object.keys(options.obj).find(key => options.obj[key] === value)
    }
    return localeKey ? i18n.t(`${path}.${localeKey}`) : i18n.t('emptyValue')
  },
  formatCurrency (value, options = {}) {
    const currentRegion = store.getters['regions/currentRegion'] || {}
    const currency = options.currencyCode || currentRegion.currency
    const suffix = options.withSpace ? ' ' : ''
    if (!isNaN(value) || options.force) {
      return `${currency}${suffix}${currencyFormatter.format(value, 'USD')}`
    } else {
      return i18n.t('emptyValue')
    }
  },
  isEmptyValue (value) {
    if (value === undefined || value === null || value === '') {
      return i18n.t('emptyValue')
    }
    return value
  },
  showStatusLabel (boolean) {
    const key = userStatusMapping[!!boolean]
    return i18n.t(`status.${key}`)
  },
  customStatusLabel (option, key) {
    const localeKey = key ? option[key] : option
    if (!localeKey || localeKey === emptyValue) return emptyValue
    return i18n.t(`status.${localeKey.toLowerCase().replace(/\W+/g, '_')}`)
  },
  customYNLabel (option) {
    return i18n.t(option.toLowerCase())
  },
  customTProjectTypeLabel (option, key) {
    const localeKey = key ? option[key] : option
    if (!localeKey || localeKey === emptyValue) return emptyValue
    return i18n.t(`tenancyProject.${localeKey.toLowerCase()}`)
  },
  customTimeLabel (option) {
    return i18n.t(`tenancyProject.timeOptions.${option.label.toLowerCase().replace(/\W/g, '_')}`)
  },
  customWorkingDayLabel (option) {
    return option ? i18n.t(`workDayOptions.${option}`) : ''
  },
  customWorkingHourLabel (option) {
    return option === 'Anytime' ? i18n.t(`workingHoursOption.${option}`) : option
  },
  chooseRegion (i18nPath, region) {
    const { name } = store.getters['regions/currentRegion'] || {}
    const selectedRegion = region || name
    const regionalI18nPath = `${i18nPath}.${selectedRegion}`
    const hasI18n = i18n.te(regionalI18nPath)
    if (hasI18n) return regionalI18nPath
    console.warn(`i18n path ${regionalI18nPath} not found, ${JSON.stringify(i18n.t(i18nPath))}`)
    return i18nPath
  },
  i18n (value, ...args) {
    return i18n.t(value, args)
  },

}

export default filters
